// import components
import { DefaultReadModeRenderer } from './withReadModeFieldRenderers';

// import context
import { useEditPageContext } from '../EditPageContext';

// types
import { type ReactNode } from 'react';
import type { WithReadModeFieldPropsBase } from './withReadModeField.types';

const withReadModeField =
  <CProps extends object>(Component: React.FC<CProps>) =>
  (
    props: CProps &
      WithReadModeFieldPropsBase & {
        readModeRenderer?: (
          props: WithReadModeFieldPropsBase & any
        ) => ReactNode;
      }
  ) => {
    const isEditable =
      props.disabled !== undefined
        ? !props.disabled
        : useEditPageContext().isEditable;

    if (!isEditable) {
      if (props.readModeRenderer) {
        return props.readModeRenderer({
          name: props.name,
          label: props.label
        });
      }

      return (
        <DefaultReadModeRenderer
          name={props.name}
          label={props.label}
          options={props.options}
          labelGetter={props.labelGetter}
          valueGetter={props.valueGetter}
          valueFormatter={props.valueFormatter}
          disableLabel={props.disableLabel}
        />
      );
    }

    return <Component {...props} disabled={!isEditable} />;
  };

export default withReadModeField;
